import { translateManager as t } from 'services/TranslateManager'
import { formatPrice } from 'utils/utils'
import SummaryItem from 'components/SummaryItem/SummaryItem'

function TotalPriceSummaryItem({ totalPrice, currency }) {
  return (
    <SummaryItem
      text={t.get('order.checkout.payment_summary_rows.total')}
      strong
      testId="total-summary-item"
    >
      {formatPrice(totalPrice, currency)}
    </SummaryItem>
  )
}

export default TotalPriceSummaryItem
